
import React from "react";
import "./AvanceModulo.scss";
import Progreso from "./Progreso";
import { ProgressBar } from "primereact/progressbar";
import { Tooltip } from "primereact/tooltip";
function AvanceModulosComponent({
  listaCursoPrograma,
  listaProgresoLeccionUnidadeCursoPrograma,
  listaUnidadeCursoPrograma,
  listaLeccionUnidadeCursoPrograma,
  listaEvaluacionesUnidadeCursoPrograma,
  CursoEvaluacion,
}) {


  function calcularPromedioNotasPorUnidad() {
    if (listaEvaluacionesUnidadeCursoPrograma) {
      const notasMaximasPorUnidad = {};
      const conteoEvaluacionesPorUnidad = {};
      listaEvaluacionesUnidadeCursoPrograma.forEach((evaluacion) => {
        const { idUnidad, nota } = evaluacion;
        if (
          !notasMaximasPorUnidad[idUnidad] ||
          nota > notasMaximasPorUnidad[idUnidad]
        ) {
          notasMaximasPorUnidad[idUnidad] = nota;
        }
        if (!conteoEvaluacionesPorUnidad[idUnidad]) {
          conteoEvaluacionesPorUnidad[idUnidad] = 1;
        } else {
          conteoEvaluacionesPorUnidad[idUnidad]++;
        }
      });
/*       let sumaNotas = 0;
      let totalUnidades = 0;
      var totalNotaCurso =0
      const notasMaximasPorCurso = {}; */

      var notaCursoPromedo =0;
      listaCursoPrograma .forEach((curso)=>{
        var unidades = listaUnidadeCursoPrograma.filter(x => x.idCurso === curso.idCurso )
        var notaCurso = 0;
        unidades.forEach((unidad)=>{
          notaCurso = notaCurso + (notasMaximasPorUnidad[unidad.idUnidad] ?? 0)
        })
        notaCursoPromedo = notaCursoPromedo + (notaCurso / unidades.length)

      })
      notaCursoPromedo = notaCursoPromedo.toFixed() / listaCursoPrograma.length
      //console.log(notaCursoPromedo);
/*       for (const unidad in notasMaximasPorUnidad) {
        sumaNotas += notasMaximasPorUnidad[unidad];
        totalUnidades++;
      }
      const promedio = totalUnidades === 0 ? 0 : sumaNotas / totalUnidades;
 */
      return notaCursoPromedo.toFixed();
    } else {
      return 0;
    }
  }
  function ProgresoProgramaCursoPormedioProgressBar(props) {
    const uniqueClassName = `Tooltiptrue-${props.idCurso}`;

    if (listaProgresoLeccionUnidadeCursoPrograma != null) {
      var Sum = listaProgresoLeccionUnidadeCursoPrograma
        .filter((x) => x.idCurso === props.idCurso)
        .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      var UnidadesPorCurso = listaUnidadeCursoPrograma.filter(
        (x) => x.idCurso === props.idCurso
      );
      var auxListadeLeccionesPorUnidad = [];
      var evaluacionCurso = 0;
      for (var i = 0; i < UnidadesPorCurso.length; i++) {
        var LeccionesPOrUnidad = listaLeccionUnidadeCursoPrograma.filter(
          (x) => x.idUnidad === UnidadesPorCurso[i].idUnidad
        );
        for (var j = 0; j < LeccionesPOrUnidad.length; j++) {
          auxListadeLeccionesPorUnidad.push(LeccionesPOrUnidad[j]);
        }
        var evaluacionCursoFilter =
          listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) =>
              x.idUnidad === UnidadesPorCurso[i].idUnidad && x.intento === 1
          );
        evaluacionCurso = evaluacionCurso + evaluacionCursoFilter.length;
      }
      const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length / 2;
      const evaluacionPorcentaje =
        (evaluacionCurso * 100) / UnidadesPorCurso.length / 2;
      return (
        <>


          <ProgressBar
            style={{ height: "8px", borderRadius: 0, width: "100%" }}
            color={props.Color ? props.Color : "#FFB62F"}
            value={(PorcentajeCurso + evaluacionPorcentaje).toFixed()}
            className={`text-sm `}
          //className={`text-sm ${props.nombre.length > 28 ? uniqueClassName : ""}`}
          ></ProgressBar>
          {/* <Tooltip
                target={`.${uniqueClassName}`}
                content={props.nombre}
                className="white-tooltip"
            /> */}
        </>


      );
    } else {
      return (
        <ProgressBar
          style={{ height: "8px", borderRadius: 0 }}
          color="#FFB62F"
          value={0}
        ></ProgressBar>
      );
    }
  }

  function ProgresoProgramaCursoPormedio(props) {
    if (
        listaProgresoLeccionUnidadeCursoPrograma &&
        listaEvaluacionesUnidadeCursoPrograma
    ) {
        var Sum = listaProgresoLeccionUnidadeCursoPrograma
            .filter((x) => x.idCurso === props.idCurso)
            .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
        var UnidadesPorCurso = listaUnidadeCursoPrograma.filter(
            (x) => x.idCurso === props.idCurso
        );
        var auxListadeLeccionesPorUnidad = [];
        var evaluacionCurso = 0;
        for (var i = 0; i < UnidadesPorCurso.length; i++) {
            var LeccionesPOrUnidad = listaLeccionUnidadeCursoPrograma.filter(
                (x) => x.idUnidad === UnidadesPorCurso[i].idUnidad
            );
            for (var j = 0; j < LeccionesPOrUnidad.length; j++) {
                auxListadeLeccionesPorUnidad.push(LeccionesPOrUnidad[j]);
            }
            var evaluacionCursoFilter =
                listaEvaluacionesUnidadeCursoPrograma.filter(
                    (x) =>
                        x.idUnidad === UnidadesPorCurso[i].idUnidad && x.intento === 1
                );
            evaluacionCurso = evaluacionCurso + evaluacionCursoFilter.length;
        }
        const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length / 2;
        const evaluacionPorcentaje =
            (evaluacionCurso * 100) / UnidadesPorCurso.length / 2;

        return <span>{(PorcentajeCurso + evaluacionPorcentaje).toFixed()}</span>;
    } else {
        return <span>0.00</span>;
    }
  }

  function Itemcursonombre(props) {
    const uniqueClassName = `Tooltiptrue-${props.idCurso}`;
    return (
      <>
        <b className={`text-sm ${props.nombre.length > 28 ? uniqueClassName : ""}`}>
          {props.nombre.length > 28 ? props.nombre.substring(0, 28) + "..." : props.nombre}</b>
        {/* <Tooltip
          target={`.${uniqueClassName}`}
          content={props.nombre}
          className="white-tooltip"
          position="bottom"
        /> */}
      </>
    )
  }
  return (
    <div className="p-fluid formgrid grid">
      <div className="field col-12 md:col-12 movilBackgroundPreguntas" style={{paddingRight:"inherit"}}>
        <div
          className=" rounded-9 shadow p-3 p-md-4  mb-md-4"
          style={{ background: "white" }}
        >
          <span className=" subtitulo__avance__progreso " data-v-48f3e599="">
            Avance de módulos
          </span>
          <div className="contenedor__avance progreso-desktop-block">
            {listaCursoPrograma &&
              listaCursoPrograma.map((item, i) => {
                return (
                  <Progreso item={item} listaProgresoLeccionUnidadeCursoPrograma={listaProgresoLeccionUnidadeCursoPrograma} listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma} listaUnidadeCursoPrograma={listaUnidadeCursoPrograma} listaEvaluacionesUnidadeCursoPrograma={listaEvaluacionesUnidadeCursoPrograma} CursoEvaluacion={CursoEvaluacion} />
                );
              })}
          </div>
          <div className="contenedor__avance progreso-mobile">
            {listaCursoPrograma &&
              listaCursoPrograma.map((item, i) => {
                return (
                  <div className="p-fluid formgrid grid ">
                    <div className="field col-12 md:col-3 contenedor__avance" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginBottom:"3%" }} >
                    <Itemcursonombre idCurso={item.idCurso} nombre={item.curso.nombre}/>
                    </div>
                    <div className="field col-5 md:col-5 avance_progreso_barra">
                      <ProgresoProgramaCursoPormedioProgressBar
                        idCurso={item.idCurso} nombre={item.curso.nombre}
                      />
                    </div>

                    <div className="field col-2 md:col-1 avance_progreso_porcentaje ">
                      <span className="fontsizesmall ">
                        <ProgresoProgramaCursoPormedio idCurso={item.idCurso} />%&nbsp; &nbsp;
                      </span>
                    </div>
                    <div className="field col-5 md:col-3 avance_progreso_promedio ">
                      <CursoEvaluacion idCurso={item.idCurso} />
                    </div>
                  </div>
                );
              })}
          </div>

          <span class="subtitle h4" data-v-48f3e599="">

            <span class="subtitle h5" data-v-48f3e599="">
              <span>
                Promedio total del programa:{" "}
                {calcularPromedioNotasPorUnidad()
                  ? calcularPromedioNotasPorUnidad()
                  : "--"}
              </span>
            </span>
          </span>
        </div>

      </div>
    </div>
  );
}

export default AvanceModulosComponent;
